//Evaluation

export const GetAllEvaluationTypes = () => {

  return $.get('Evaluation/GetAllEvaluationTypes?IsActive=null')
}

export const AddEvaluationType = (model) => {
  return $.post('Evaluation/AddEvaluationType', model)
}

export const UpdateEvaluationType = (model) => {

  return $.post('Evaluation/UpdateEvaluationType', model)
}

export const DeleteEvaluationType = (id) => {
  return $.post('Evaluation/DeleteEvaluationType?Id=' + id)
}

export const ChangeEvaluationTypeOrdinance = (model) => {

  return $.ajax({
    url: 'Evaluation/ChangeEvaluationTypeOrdinance',
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}

// Performance  Level

export const ChangePerformanceLevelOrdinance = (model) => {

  return $.ajax({
    url: 'Evaluation/ChangePerformanceLevelOrdinance',
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}

export const GetAllPerformanceLevels = (id) => {
  return $.get('Evaluation/GetAllPerformanceLevels?IsActive=null')
}

export const AddPerformanceLevel = (model) => {
  return $.post('Evaluation/AddPerformanceLevel', model)
}

export const UpdatePerformanceLevel = (model) => {

  return $.post('Evaluation/UpdatePerformanceLevel', model)
}

export const DeletePerformanceLevel = (id) => {
  return $.post('Evaluation/DeletePerformanceLevel?Id=' + id)
}





// WEBPACK FOOTER //
// ./src/components/EvaluationManage/EvaluationManage.service.js